import { BronzeBadge, GoldBadge, SilverBadge, Verified } from "@gigpro/ui/Icons";
import { cn } from "@gigpro/ui/tailwind/cn";
import { Tooltip } from "@gigpro/ui/Tooltip";
import { type ProBadge, proBadges } from "api/resources/pros";
import React from "react";

export interface ProBadgesProps extends React.HTMLAttributes<HTMLDivElement> {
  badges: ProBadge | null | undefined;
}

const badge: Record<ProBadge[number], React.ReactNode> = {
  VERIFICATION: <Verified key="Verified" className="h-full w-auto text-info" />,
  GOLD: <GoldBadge key="GoldBadge" className="h-full w-auto" />,
  SILVER: <SilverBadge key="SilverBadge" className="h-full w-auto" />,
  BRONZE: <BronzeBadge key="BronzeBadge" className="h-full w-auto" />,
};

// Hover-tooltip copy per badge. The icons alone aren't self-explanatory
// for first-time viewers (staffers / new admins) — surfaces the meaning
// without adding visible text next to the icon. TOP_PRO has no entry: it
// is filtered out before render (kept on the BE for compatibility per the
// model comment, but no FE display).
const BADGE_TOOLTIP: Partial<Record<ProBadge[number], string>> = {
  VERIFICATION: "Verified pro — passed Qwick's identity verification",
  GOLD: "Gold tier pro — top performance tier",
  SILVER: "Silver tier pro — mid performance tier",
  BRONZE: "Bronze tier pro — entry performance tier",
};

export const ProBadges = ({ badges, className, ...rest }: ProBadgesProps) => {
  if (!badges?.length) return null;
  const badgesFiltered = proBadges.filter((key) => (key === "TOP_PRO" ? false : badges.includes(key)));

  return (
    <div className={cn("relative flex h-5 items-center gap-1 px-1 py-px", className)} {...rest}>
      {badgesFiltered.map((key) =>
        key === "TOP_PRO" ? null : (
          <Tooltip key={key} content={BADGE_TOOLTIP[key]}>
            <span className="inline-flex h-full cursor-help items-center">{badge[key]}</span>
          </Tooltip>
        ),
      )}
    </div>
  );
};
